import Vue from 'vue';
import http from './http.js';
import store from '@/store/index';
import utils from '@/utils/utils';

/** post请求：isShowAlert参数为true显示异常提示框，false不显示 */
function post(mUrl, params, isShowAlert = true) {
  const hash = utils.getLangAndCurrencyFromLocal();

  params = Object.assign({}, {currency_code: hash.currency_code, lan_type: hash.lan_type, language: hash.lan_type}, params);

  return http.doPost(mUrl, params).then(resolve => {
    const resp = resolve.data;

    /** 30509 是priceChecker接口 价格不一致时返回 **/
    if(Number(resp.code) !== 1 && Number(resp.code) !== 30509){
      if(isShowAlert){
        Vue.$vux.alert.show({
          content: resp.msg,
          onHide(){
            if(Number(resp.code) === -1000 || Number(resp.code) === -1001){
              const curLocal = encodeURIComponent(window.location.href);

              window.location.href = `${store.state.WAP_HOST}login.php?redirect_url=${curLocal}`;
            }
          },
        });
      }

      // bcc密码错误
      if(Number(resp.code) === 30902){
        return resp;
      }

      return ;
    }

    return resp;
  }).catch(err => {
    Vue.$vux.alert.show({
      content: err.toString(),
    });
  });
}

/** get请求: isShowAlert参数为true显示异常提示框，false不显示 */
function get(mUrl, params, isShowAlert = true) {
  const hash = utils.getLangAndCurrencyFromLocal();

  params = Object.assign({}, {currency_code: hash.currency_code, lan_type: hash.lan_type, language: hash.lan_type}, params);

  return http.doGet(mUrl, params).then(resolve => {
    const resp = resolve.data;

    if(Number(resp.code) !== 1 && isShowAlert){
      Vue.$vux.alert.show({
        content: resp.msg,
        onHide(){
          if(Number(resp.code) === -1000 || Number(resp.code) === -1001){
            const curLocal = encodeURIComponent(window.location.href);

            window.location.href = `${store.state.WAP_HOST}login.php?redirect_url=${curLocal}`;
          }
        },
      });
      return ;
    }
    return resp;
  }).catch(err => {
    Vue.$vux.alert.show({
      content: err.toString(),
    });
  });
}

/**
 * 酒店搜索
 */
export class HotelSearchProxy {
  constructor(){

  }

  /** 获取酒店热门城市数据 */
  getHotRegion(params = {}){
    const url = 'RegionSearch';

    return get(url, params);
  }

  /** 地区或酒店搜索 */
  searchRegionOrHotel(params = {}){
    // const url = 'Place';
    const url = 'Place/V4';

    params = Object.assign({}, params, {is_show_landmark: 1});
    return get(url, params);
  }

  /** 获取酒店搜索列表数据 */
  getHotelList(params = {}){
    const url = 'Hotel';

    return get(url, params);
  }

  /** 获取推荐酒店数据 */
  getRecommendRHotel(params){
    const url = 'Hotel/Recommend';

    return get(url, params);
  }

  /** 获取酒店筛选条件数据 */
  getHotelFilterConditions(params = {}){
    const url = 'Hotel/SearchOptions';

    return get(url, params);
  }

  /** 获取酒店筛选条件数据_V2 */
  getHotelFilterConditions_V2(params = {}){
    const url = 'Hotel/SearchOptionsV2';

    return get(url, params);
  }
}

/**
 * 酒店类
 */
export class HotelProxy{
  constructor(){

  }

  /** 获取酒店详情(废弃) */
  getHotelDetail(params = {}){
    const url = `Hotel/${params.hotel_id}`;

    params = Object.assign({}, params, {lan_type: 1});
    delete params.hotel_id;
    return get(url, params);
  }

  /** 获取酒店基本信息 */
  getHotelBaseInfo(params = {}){
    const url = `HotelInfo/${params.hotel_id}`;

    params = Object.assign({}, params, {lan_type: 1});
    delete params.hotel_id;
    return get(url, params);
  }

  /** 获取酒店房型 */
  getHotelRooms(params = {}){
    // const url = `HotelPrice/${params.hotel_id}`;
    const url = `HotelPrice/searchBySupplier`;

    params = Object.assign({}, params, {lan_type: 1});
    // delete params.hotel_id;
    return post(url, params, false);
  }

  /** 获取酒店配置内容数据，如bcc广告和信用卡正则表达式等 */
  getHotelConfig(){
    const url = 'HotelConfig';

    return get(url, {});
  }

  /** 提交评价内容 */
  submitEvaluation(params = {}){
    const url = 'Hotel/Review';

    return post(url, params);
  }

  /** 获取评价列表数据 */
  getHotelEvaluationList(params = {}){
    const url = 'Hotel/Review';

    return get(url, params);
  }

  /** 酒店收藏 */
  collectionHotel(params = {}){
    const url = 'HotelInfo/updateCollectionStatus';

    return post(url, params);
  }
}

/**
 * 订单类
 */
export class OrderProxy{
  constructor(){

  }

  /** 检查登陆状态 */
  checkLoginStatus(params = {}){
    const url = 'User';

    return get(url, params);
  }

  /** 获取用户钱包数据 */
  getUserWallet(){
    const url = 'UserWallet';

    return get(url);
  }

  /** 酒店下单信息 */
  prepareHotelOrder(params = {}){
    const url = `OrderPrepare/${params.order_type}`;

    delete params.order_type;
    delete params.hotel_id;
    return get(url, params);
  }

  /** 酒店下单（普通下单） */
  placingHotelOrder(params){
    const url = 'HotelOrder';

    return post(url, params, false);
  }

  /** 酒店下单（BCC会员下单） */
  placingHotelOrderWithBCC(params){
    const url = 'BCCBooking';

    return post(url, params, false);
  }

  /** 订单详情 */
  getOrderDetail(params = {}){
    const url = `OrderUnion/${params.order_id}`;

    return get(url, params);
  }

  /** 取消订单 */
  cancelOrder(params = {}){
    const url = 'OrderUnion/cancelOrder';

    return post(url, params);
  }

  /** 检测订单价格是否有变动 */
  priceChecker(params = {}){
    const url = 'PriceChecker';

    return post(url, params);
  }

  /** 获取各个国家的手机区号列表 */
  getCountryPhoneCode(){
    const url = 'CountryPhoneCode';

    return get(url);
  }

  /** 获取用户所持优惠券列表 */
  getCouponData(params = {type: 3}){
    const url = 'HotelCoupon';

    return get(url, params);
  }

  /** 绑定优惠券 */
  bindNewCoupon(params = {}){
    const url = 'HotelCoupon';

    return post(url, params);
  }
}

/**
 * 订单支付类
 */
export class PaymentProxy {
  constructor(){

  }

  /** 获取订单支付信息 */
  getPaymentInfo(params = {}){
    const url = `PayOrder/${params.orderId}`;

    return get(url);
  }

  /** 订单支付 */
  submitPayment(params = {}){
    const url = `PayOrder`;

    return post(url, params);
  }

  /** 获取安全码 */
  getSecurityCode(params = {}){
    const url = 'SecretTradeKey';

    return post(url, params);

  }
}

/**
 * 图片类
 */
export class ImageProxy{
  constructor(){

  }

  /** 获取酒店全部数据 */
  getHotelAllImages(params = {}){
    const url = 'Images';

    return get(url, params);
  }
}

/**
 * 微信相关接口
 */
export class WechatProxy {
  constructor(){

  }

  /** 获取微信公众号配置信息 */
  getWxConfig(params = {}){
    const url = 'WechatJsConfig';

    return get(url, params);
  }
}



// WEBPACK FOOTER //
// ./src/http/RequestProxy.class.js